import { HTTPError, TimeoutError } from "ky";

/**
 * Extract message seamlessly from HTTP or standard error objects
 * @param error object from catch block
 * @returns error message
 */
export const handleError = async (error: unknown): Promise<string> => {
  if (error instanceof HTTPError) {
    try {
      const apiError = await error.response.json();
      return apiError.message;
    } catch (err) {
      return undefined; // Body has already been consumed
    }
  } else if (error instanceof TimeoutError) {
    return error.message;
  } else {
    return error?.toString() ?? "An error occured";
  }
};
